import React from "react";
import { Icon, Tooltip } from "@culturehq/components";

import { t, Trans } from "app/utils";

export const isFirstDay = event => {
  const currentTime = new Date();

  const startsAt = new Date(event.startsAt);
  const endsAt = new Date(event.endsAt);

  const firstDayEndsAt = new Date(event.startsAt);
  firstDayEndsAt.setDate(firstDayEndsAt.getDate() + 1);

  return currentTime >= startsAt && currentTime < endsAt && currentTime < firstDayEndsAt;
};

const Live = ({ event }) => {
  if (!isFirstDay(event) || event.cancelledAt) {
    return null;
  }

  return (
    <div className="live-wrapper">
      <Tooltip tip={t("This event is live. Live events lasting more than one day appear in the \"Ongoing\" tab after 24 hours.")}>
        <span className="live">
          <Icon icon="record" />
          {" "}
          <Trans>LIVE</Trans>
        </span>
      </Tooltip>
    </div>
  );
};

export default Live;
